import { create } from 'zustand';

export interface Toast {
  id: string;
  kind: 'info' | 'warn' | 'error' | 'success';
  message: string;
  ttlMs: number;
}

interface UiState {
  toasts: Toast[];
  lightingWarn: boolean;
  pushToast(t: Omit<Toast, 'id'>): void;
  dismiss(id: string): void;
  setLightingWarn(v: boolean): void;
}

export const useUi = create<UiState>((set, get) => ({
  toasts: [],
  lightingWarn: false,
  pushToast(t) {
    const id = crypto.randomUUID();
    set({ toasts: [...get().toasts, { ...t, id }] });
    setTimeout(() => get().dismiss(id), t.ttlMs);
  },
  dismiss(id) {
    set({ toasts: get().toasts.filter((x) => x.id !== id) });
  },
  setLightingWarn(v) {
    set({ lightingWarn: v });
  },
}));
